// eslint-disable-next-line import/prefer-default-export
export const HOTEL_INFO_SECTION = "hotel_info_section";
